import { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

const api = require("../Assets/api.json");

function Login(props) {
  const [show, setShow] = useState(true);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleClose = () => setShow(false);

  const loginPressed = async () => {
    try {
      if (username && username.length > 2 && password && password.length > 2) {
        let formdata = new FormData();
        formdata.append("password", password);
        formdata.append("username", username);

        const response = await fetch(api.endpoints.login, {
          method: "POST",
          body: formdata,
        });
        const resp = await response.json();

        if (resp.message === "Login Successful") {
          localStorage.setItem("esri-tile-converter-token", resp.authKey);
          localStorage.setItem("esri-tile-converter-username", username);
          localStorage.setItem("esri-tile-converter-password", password);
          props.onLogin(resp.message);
        } else {
          props.onLogin("Login Failed");
          console.log("Login Failed");
        }
      } else {
        props.onLogin("Login Failed");
        console.log("invalid username and password");
      }
    } catch (error) {
      props.onLogin("Login Failed");
      console.log(error);
    }
  };

  return (
    <div>
      <Modal show={show} centered>
        <Modal.Header>
          <Modal.Title>Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="esri-username">
              <Form.Label>Email/Username</Form.Label>
              <Form.Control
                type="email"
                placeholder="name@example.com"
                defaultValue={username}
                onChange={(event) => setUsername(event.target.value)}
                autoFocus
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="esri-password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder=""
                autoFocus
                defaultValue={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={loginPressed}>
            Login
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
export default Login;
